import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ServiceFeature {
  title: string;
  description: string;
}

export interface ServiceHighlight {
  topic: string;
  detail: string;
}

export interface ContactInfo {
  phone: string;
  email: string;
  location: string;
}

export interface Service {
  id: number;
  title: string;
  slug: string;
  category: string;
  image: string;
  image2: string;
  youtube: string;
  date: string;
  author: string;
  summary: string;
  mainContent: {
    title: string;
    description: string;
    content: ServiceFeature[];
  };
  subContent: {
    title: string;
    description: string;
    othercontent: string;
    highlight: ServiceHighlight[];
  };
  contactInfo: ContactInfo;
  metaTags: Array<{
    name: string;
    content: string;
  }>;
}

@Injectable({
  providedIn: 'root'
})
export class ServiceDetail {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getServiceBySlug(slug: string): Observable<Service> {
    return this.http.get<Service>(`${this.apiUrl}/services/${slug}`);
  }
} 